import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CapitalActionFormValues } from './useCapitalActionForm';
import { pluralize } from 'further-ui/utils';

const entryTypesTitles = {
  [CapitalActionEntryType.Expense]: 'Expense',
  [CapitalActionEntryType.Investment]: 'Investment',
  [CapitalActionEntryType.Fees]: 'Fees',
  [CapitalActionEntryType.GeneralCapitalCall]: 'General capital call',
  [CapitalActionEntryType.CapitalContributionCall]: 'Capital contribution call',
  [CapitalActionEntryType.CapitalRefund]: 'Return of capital',
  [CapitalActionEntryType.CapitalDistribution]: 'Distribution',
  [CapitalActionEntryType.Equalisation]: 'Equalisation',
};

export default function useGetEntryTitle() {
  const getEntryTitle = (entry: CapitalActionFormValues['entries'][number]) => {
    if (
      [
        CapitalActionEntryType.GeneralCapitalCall,
        CapitalActionEntryType.CapitalContributionCall,
        CapitalActionEntryType.CapitalRefund,
        CapitalActionEntryType.CapitalDistribution,
      ].includes(entry.entryType)
    ) {
      return `Capital call - ${entryTypesTitles[entry.entryType]}`;
    }

    return `Capital call - ${entryTypesTitles[entry.entryType]} (${
      entry.actions.length
    } ${pluralize('transaction', entry.actions.length)})`;
  };

  return getEntryTitle;
}
